export const MondayColors = [
  "#65ccfd",
  "#00c875",
  "#ffcb00",
  "#5458df",
  "#9d50dd",
  "#ff7474",
  "#ff6b6b",
];
